import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ProjectSection from "./ProjectSection";
import BlogSlider from "../../components/BlogList/BlogTopList";

const ProjectPage: React.FC = () => {
  useEffect(() => {
                              document.title = "Projects | Brain Machine AI";
                            }, []);
  return (
    <Fragment>
      <div className='service-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Our projects" pagesub="Our projects" />
            <BlogSlider></BlogSlider>
            <ProjectSection/>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProjectPage;
